export default __webpack_public_path__ + "static/media/020_start.last.fe4a0f40.webp";